import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const valuePropType = T.oneOfType([T.string, T.number]);

const SelectOption = props => {
  const {
    value,
    children
  } = props,
        otherProps = _objectWithoutPropertiesLoose(props, ["value", "children"]);

  return /*#__PURE__*/_jsx("option", Object.assign({
    value: value
  }, otherProps, {
    children: children || value
  }));
};

SelectOption.propTypes = {
  value: valuePropType.isRequired,
  children: T.node
};
export { SelectOption, valuePropType };